'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { Flag } from '@7f-ui/components/flag/flag';
import { Price } from '@7f-ui/components/price';
import { PriceWithDiscount } from '@7f-ui/components/price-with-discount';
import { formatGermanNumber } from '@utils/utils-format';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { getTouristTaxType } from '../pricing';
import { useBeachChairModel } from '../src/hooks/use-beach-chair-model';
import type { Cart, CartItem } from '../src/hooks/use-cart';
type CartSummaryProps = {
  cart: Cart;
  title?: string;
  microdata?: boolean;
  highlightTaxNote?: boolean;
  showItems?: boolean;
};
type SummaryRow = {
  key: string;
  type: string;
  title: string;
  count: number;
  total: number;
  isBlocked: boolean;
};
const ITEM_TYPE_LABELS: Record<string, string> = {
  ACCOMMODATION: 'Unterkunft',
  BEACH_CHAIR: 'Strandkorb',
  EXPERIENCE: 'Erlebnis',
  RENTABLE_BIKE: 'Fahrräder'
};
const TOURIST_TAX_TYPE_LABELS: Record<string, string> = {
  CityTax: 'Übernachtungssteuer',
  SpaTax: 'Kurtaxe'
};
export function CartSummary(t0) {
  const $ = _c(61);
  const {
    cart,
    title,
    microdata,
    highlightTaxNote,
    showItems: t1
  } = t0;
  const showItems = t1 === undefined ? true : t1;
  const rows = useSummaryRows(cart.items.all);
  let t2;
  if ($[0] !== cart) {
    t2 = getTouristTaxType(cart);
    $[0] = cart;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const touristTaxType = t2;
  const discount = cart.discount ?? 0;
  const originalTotal = cart.total + discount;
  let t10;
  let t11;
  let t12;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== cart.currency || $[3] !== cart.promotionCodeName || $[4] !== cart.promotionCodeType || $[5] !== cart.promotionCodeValue || $[6] !== discount || $[7] !== originalTotal || $[8] !== rows || $[9] !== showItems || $[10] !== title) {
    const discountPercentage = discount > 0 ? Math.round(discount / originalTotal * 100) : 0;
    t8 = "flex flex-col gap-3";
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = shopTestId("CartSummary.root");
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    if ($[22] !== title) {
      t10 = title && <h2 className="font-heading3">{title}</h2>;
      $[22] = title;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    if ($[24] !== cart.currency || $[25] !== cart.promotionCodeName || $[26] !== cart.promotionCodeType || $[27] !== cart.promotionCodeValue || $[28] !== discount || $[29] !== rows || $[30] !== showItems) {
      t11 = showItems && <div className="flex flex-col gap-1">{rows.map(row => <div key={row.key} className={cx("flex justify-between gap-4 font-body-small", {
          "text-error": row.isBlocked
        })}><span>{`${row.count}x ${ITEM_TYPE_LABELS[row.type] ?? row.type} „${row.title}“`}</span><Price amount={row.total} currency={cart.currency} /></div>)}<PriceWithDiscount name={cart.promotionCodeName} discount={discount} type={cart.promotionCodeType} value={cart.promotionCodeValue} currency={cart.currency} /></div>;
      $[24] = cart.currency;
      $[25] = cart.promotionCodeName;
      $[26] = cart.promotionCodeType;
      $[27] = cart.promotionCodeValue;
      $[28] = discount;
      $[29] = rows;
      $[30] = showItems;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <div className="w-full border-primary/15 border-t" />;
      $[32] = t12;
    } else {
      t12 = $[32];
    }
    t7 = "flex flex-col";
    t5 = "flex items-end justify-between gap-4";
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <p className="font-heading3">Gesamtpreis</p>;
      $[33] = t6;
    } else {
      t6 = $[33];
    }
    t3 = "flex flex-col items-end gap-1";
    t4 = discountPercentage > 0 && <div className="flex items-center gap-2"><Price amount={originalTotal} currency={cart.currency} strikethrough={true} /><Flag variant="success">{`- ${formatGermanNumber(discountPercentage)}%`}</Flag></div>;
    $[2] = cart.currency;
    $[3] = cart.promotionCodeName;
    $[4] = cart.promotionCodeType;
    $[5] = cart.promotionCodeValue;
    $[6] = discount;
    $[7] = originalTotal;
    $[8] = rows;
    $[9] = showItems;
    $[10] = title;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  const t13 = cart.total;
  const t14 = cart.currency;
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = shopTestId("CartSummary.total");
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== cart.currency || $[36] !== cart.total || $[37] !== microdata) {
    t16 = <Price amount={t13} currency={t14} className="font-heading3" dataTestId={t15} microdata={microdata} />;
    $[35] = cart.currency;
    $[36] = cart.total;
    $[37] = microdata;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t16 || $[40] !== t3 || $[41] !== t4) {
    t17 = <div className={t3}>{t4}{t16}</div>;
    $[39] = t16;
    $[40] = t3;
    $[41] = t4;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t17 || $[44] !== t5 || $[45] !== t6) {
    t18 = <div className={t5}>{t6}{t17}</div>;
    $[43] = t17;
    $[44] = t5;
    $[45] = t6;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== highlightTaxNote || $[48] !== touristTaxType) {
    t19 = touristTaxType ? <p className="font-body-small">{`inkl. MwSt. zzgl. ${TOURIST_TAX_TYPE_LABELS[touristTaxType] ?? touristTaxType}`}</p> : <p className={cx("font-body-small", {
      "text-success": highlightTaxNote,
      "text-secondary-text": !highlightTaxNote
    })}>Alle Steuern und Gebühren inklusive</p>;
    $[47] = highlightTaxNote;
    $[48] = touristTaxType;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t18 || $[51] !== t19 || $[52] !== t7) {
    t20 = <div className={t7}>{t18}{t19}</div>;
    $[50] = t18;
    $[51] = t19;
    $[52] = t7;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== t10 || $[55] !== t11 || $[56] !== t12 || $[57] !== t20 || $[58] !== t8 || $[59] !== t9) {
    t21 = <div className={t8} data-testid={t9}>{t10}{t11}{t12}{t20}</div>;
    $[54] = t10;
    $[55] = t11;
    $[56] = t12;
    $[57] = t20;
    $[58] = t8;
    $[59] = t9;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  return t21;
}
function useSummaryRows(items) {
  const $ = _c(3);
  const {
    getBeachChairType
  } = useBeachChairModel();
  let t0;
  if ($[0] !== getBeachChairType || $[1] !== items) {
    const rows = new Map();
    items.forEach(item => {
      const title = getItemTitle(item, getBeachChairType);
      const key = `${item.__typename}-${title}`;
      const row = rows.get(key);
      if (row) {
        row.count = row.count + 1;
        row.total = row.total + item.total;
        row.isBlocked = row.isBlocked || !item.bookable;
        return;
      }
      rows.set(key, {
        key,
        type: getItemType(item),
        title,
        count: 1,
        total: item.total,
        isBlocked: !item.bookable
      });
    });
    t0 = [...rows.values()];
    $[0] = getBeachChairType;
    $[1] = items;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function getItemType(item: CartItem) {
  switch (item.__typename) {
    case 'CartItemExperience':
      return 'EXPERIENCE';
    case 'CartItemAccommodation':
      return 'ACCOMMODATION';
    case 'CartItemBeachChair':
      return 'BEACH_CHAIR';
    case 'CartItemRentable':
      return 'RENTABLE_BIKE';
  }
}
function getItemTitle(item: CartItem, getBeachChairType: (model?: string | null) => string) {
  switch (item.__typename) {
    case 'CartItemExperience':
      return item.experience.title;
    case 'CartItemAccommodation':
      return item.accommodation.name;
    case 'CartItemBeachChair':
      return item.beachLocation?.city ?? getBeachChairType(item.beachChair.model);
    case 'CartItemRentable':
      return item.shopName;
  }
}